export class Guid {
    static emptyGuid = '00000000-0000-0000-0000-000000000000';
    private _guid: string;

    constructor(public guid: string) {
        this._guid = guid;
    }

    IsEmpty(): boolean {
        return !this._guid || this._guid === Guid.emptyGuid;
    }
}
